import * as React from "react";
import { sanitize } from "isomorphic-dompurify";
import { createClasses } from "@bloomberg/media-ui-core";

import styles from "./styles.module.css";

interface SummaryProps {
  className?: string;
  summary?: string;
  removeSummaryBottomMargin?: boolean;
}

export default function Summary({
  className,
  summary = "",
  removeSummaryBottomMargin,
}: SummaryProps) {
  if (!summary?.length) return null;

  /* eslint-disable react/no-danger */

  return (
    <section
      className={createClasses(
        styles.summary,
        {
          [styles.bottomMargin]: !removeSummaryBottomMargin,
        },
        className
      )}
      data-component="summary"
      dangerouslySetInnerHTML={{ __html: sanitize(summary) }}
    />
  );

  /* eslint-enable react/no-danger */
}
